// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-width: 440px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.field-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.field-label {
  flex: 0 0 100px;
  padding-top: 6px;
  font-size: 0.85rem;
}

.field-value {
  flex: 1;
  font-size: 0.85rem;
  padding-top: 6px;
}

.button-gap {
  gap: 12px;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/projects-dashboard/well-attachments-dialog/edit-description-dialog/edit-description-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX","sourcesContent":["mat-dialog-content {\n  min-width: 440px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.field-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.field-label {\n  flex: 0 0 100px;\n  padding-top: 6px;\n  font-size: 0.85rem;\n}\n\n.field-value {\n  flex: 1;\n  font-size: 0.85rem;\n  padding-top: 6px;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
